import { Bando } from "./bando.model";
import { Impresa } from "./impresa.model";
import { MandatoDiPagamento } from "./mandatoDiPagamento.model";
import { Oda } from "./oda.model";

export class EntrataDiMagazzino {
  id?: number;
  codice?: string;
  valore?: number;
  creata: Date;
  modificata: Date;
  dataEmissione: Date;
  mandatoDiPagamento:MandatoDiPagamento;
}